<template>
  <div>
    <!-- demo -->
    <!-- <global-select
      :value.sync=""
      selectType=""
      :focusGet="true"
      requestApi=""
      :selectData=""
      :selectItem="{ value: '', label: '', thirdLabel: "", thirdLabelText: '最新版本' }"
      searchParam=""
      :setParams="{}"
      :setUrlParams=""
      sourseField=""
      :sourceHandle="true"
      :allowClear="false"
      :disabled="true"
      size="small"
      :placeholder="请选择"
      :assembleLabel="true"
      :assembleLabelThrid="true"
      :getOnlyDataSelect="true"
      :defaultSelect: { defaultParam: "", defaultValue: "" }
      :totalNum="9999999999"
    /> -->
    <!-- select => value和label正常展示 + 单选 -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'select'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      show-search
      option-filter-prop="children"
      :placeholder="placeholder"
      option-label-prop="label"
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @focus="focus"
      v-bind="selectConfig"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="(item, index) in selectList"
        :key="selectItem.getCustomKeyFunc ? selectItem.getCustomKeyFunc(item, index) : item[selectItem.value]"
        :value="item[selectItem.value]"
        :label="labelHandleNoAssemble(item)"
        :title="item[selectItem.label]"
      >{{ item[selectItem.label] }}</a-select-option>
    </a-select>
    <!-- selectAssemble => value和label拼接展示 + 单选 -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectAssemble'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      option-label-prop="label"
      show-search
      option-filter-prop="children"
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      :default-active-first-option="defaultActiveFirstOption"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
        :value="item[selectItem.value]"
        :label="labelHandle(item)"
      >{{ optionAssemble(item) }}</a-select-option>
    </a-select>
    <!-- selectMultiple => value和label正常展示 + 多选 -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectMultiple'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      option-label-prop="label"
      show-search
      option-filter-prop="children"
      mode="multiple"
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      :max-tag-text-length="maxTagTextLength"
      :max-tag-count="maxTagCount"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
        :value="item[selectItem.value]"
        :label="labelHandleNoAssemble(item)"
      >{{ item[selectItem.label] }}</a-select-option>
    </a-select>
    <!-- selectAssembleMultiple => value和label拼接展示 + 多选 -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectAssembleMultiple'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      mode="multiple"
      show-search
      option-filter-prop="children"
      :max-tag-text-length="maxTagTextLength"
      :max-tag-count="maxTagCount"
      option-label-prop="label"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
        :value="item[selectItem.value]"
        :label="labelHandle(item)"
      >{{ optionAssemble(item) }}</a-select-option>
    </a-select>
    <!-- selectSearch => value和label正常展示 + 单选 + 搜索 -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectSearch'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      option-label-prop="label"
      show-search
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @search="handleSearch"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
        :value="item[selectItem.value]"
        :label="labelHandleNoAssemble(item)"
      >{{ item[selectItem.label] }}</a-select-option>
    </a-select>
    <!-- selectAssembleSearch => value和label拼接展示 + 单选 + 搜索 -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectAssembleSearch'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      option-label-prop="label"
      show-search
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @search="handleSearch"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="selectItem.getCustomKeyFunc ? selectItem.getCustomKeyFunc(item, index) : item[selectItem.value]"
        :value="item[selectItem.value]"
        :label="labelHandle(item)"
        :title="optionAssemble(item)"
      >{{ optionAssemble(item) }}</a-select-option>
    </a-select>
    <!-- selectAssembleSearchByKey => value和label拼接展示 + key + 单选 + 搜索 + 自由拼接展示label -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectAssembleSearchByKey'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      option-label-prop="label"
      show-search
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @search="handleSearch"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
        :value="item[selectItem.value]"
        :label="freeOptionAssemble(item)"
      >{{ freeOptionAssemble(item) }}</a-select-option>
    </a-select>
    <!-- selectMultipleSearch => value和label正常展示 + 多选 + 搜索 -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectMultipleSearch'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      mode="multiple"
      :max-tag-text-length="maxTagTextLength"
      :max-tag-count="maxTagCount"
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @search="handleSearch"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
      >{{ item[selectItem.label] }}</a-select-option>
    </a-select>
    <!-- selectAssembleMultipleSearch => value和label拼接展示 + 多选 + 搜索 -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectAssembleMultipleSearch'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      mode="multiple"
      :max-tag-text-length="maxTagTextLength"
      :max-tag-count="maxTagCount"
      :default-active-first-option="false"
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      :show-arrow="false"
      :filter-option="false"
      option-label-prop="label"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @search="handleSearch"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
        :value="item[selectItem.value]"
        :label="labelHandle(item)"
      >{{ optionAssemble(item) }}</a-select-option>
    </a-select>
    <!-- selectFilter => value和label正常展示 + 单选 + 匹配(父组件数据) -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectFilter'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      show-search
      option-filter-prop="children"
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      :default-active-first-option="defaultActiveFirstOption"
      :filter-option="filterOption"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
      >{{ item[selectItem.label] }}</a-select-option>
    </a-select>
    <!-- selectAssembleFilter => value和label拼接展示 + 单选 + 匹配(父组件数据) -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectAssembleFilter'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      option-label-prop="label"
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      show-search
      option-filter-prop="children"
      :filter-option="filterOption"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
        :value="item[selectItem.value]"
        :label="labelHandle(item)"
      >{{ optionAssemble(item) }}</a-select-option>
    </a-select>
    <!-- selectMultipleFilter => value和label正常展示 + 多选 + 匹配(父组件数据) -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectMultipleFilter'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      mode="multiple"
      :max-tag-text-length="maxTagTextLength"
      :max-tag-count="maxTagCount"
      show-search
      option-filter-prop="children"
      :filter-option="filterOption"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
      >{{ item[selectItem.label] }}</a-select-option>
    </a-select>
    <!-- selectAssembleMultipleFilter => value和label拼接展示 + 多选 + 匹配(父组件数据) -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectAssembleMultipleFilter'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
      mode="multiple"
      :max-tag-text-length="maxTagTextLength"
      :max-tag-count="maxTagCount"
      option-label-prop="label"
      show-search
      option-filter-prop="children"
      :filter-option="filterOption"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @focus="focus"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
        :value="item[selectItem.value]"
        :label="labelHandle(item)"
      >{{ optionAssemble(item) }}</a-select-option>
    </a-select>
    <!-- selectDropDownRefresh => value和label正常展示 + 单选、比普通版select多了下拉列表展开时刷新数据 -->
    <a-select
      ref="mySelect"
      v-if="selectType === 'selectDropDownRefresh'"
      v-model="selectValue"
      :allowClear="allowClear"
      :disabled="disabled"
      :size="size"
      show-search
      option-filter-prop="children"
      :placeholder="placeholder"
      :dropdown-match-select-width="dropdownMatchSelectWidth"
      @change="selectChange"
      @popupScroll="handlePopupScroll"
      @focus="focus"
      @dropdownVisibleChange="handleDropdownVisibleChange"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="item in selectList"
        :key="item[selectItem.value]"
      >{{ item[selectItem.label] }}</a-select-option>
    </a-select>
  </div>
</template>
<script>
import request from '@/utils/request'
import { omitBy, isEmpty } from 'lodash'

export default {
  data () {
    return {
      isInit: true, // 是否初始化
      selectValue: this.value,
      selectList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      timer: null,
      fetching: false,
      searchTypeList: ["selectSearch", "selectAssembleSearch", "selectMultipleSearch", "selectAssembleMultipleSearch", "selectAssembleSearchByKey"],
      multipleTypeList: ["selectMultiple", "selectAssembleMultiple", "selectMultipleSearch", "selectAssembleMultipleSearch", "selectMultipleFilter", "selectAssembleMultipleFilter"],
      currentSearchParams: {} // 当前搜索参数
    }
  },
  computed: {
    isMultipleSelect () {
      return this.multipleTypeList.includes(this.selectType)
    }
  },
  props: {
    value: {
      type: [String, Array],
      default: undefined
    },
    selectType: {
      type: String,
      default: "select"
    },
    focusGet: {
      type: Boolean,
      default: false
    },
    requestApi: {
      type: String,
      default: ""
    },
    selectData: {
      type: Array,
      default: () => []
    },
    selectItem: {
      type: Object,
      default: () => ({
        value: "realValue",
        label: "label"
      })
    },
    // 展示的label
    showLabel: {
      type: Object,
      default: () => ({
        value: "realValue",
        label: "label"
      })
    },
    searchParam: {
      type: String,
      default: ""
    },
    setParams: {
      type: Object,
      default: null
    },
    setUrlParams: {
      type: String,
      default: ""
    },
    sourseField: {
      type: String,
      default: ""
    },
    sourceHandle: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "default"
    },
    placeholder: {
      type: String,
      default: ""
    },
    assembleLabel: {
      type: Boolean,
      default: false
    },
    assembleLabelThrid: {
      type: Boolean,
      default: false
    },
    maxTagCount: {
      type: Number,
      default: 1
    },
    maxTagTextLength: {
      type: Number,
      default: 2
    },
    dropdownMatchSelectWidth: {
      type: Boolean,
      default: true
    },
    defaultActiveFirstOption: {
      type: Boolean,
      default: false
    },
    getOnlyDataSelect: {
      type: Boolean,
      default: false
    },
    defaultSelect: {
      type: Object,
      default: null
    },
    totalNum: {
      type: Number,
      default: 0
    },
    selectConfig: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    value (val) {
      this.selectValue = val
    },
    selectData (val) {
      // if (!this.requestApi) {
        this.selectList = val
      // }
    },
    setParams (newVal, oldVal) {
      if (this.requestApi && JSON.stringify(newVal) !== JSON.stringify(oldVal) && !this.focusGet) {
        // 防抖节流
        if (this.timer) {
          return
        }
        this.timer = setTimeout(() => {
          this.timer = null
          this.selectList = []
          this.pageNum = 1
          this.getData()
        }, 500)
      }
    }
  },
  created () {
    if (this.requestApi && !this.focusGet) {
      this.fetching = true
      this.isInit = true
      this.getData()
    } else {
      this.selectList = this.selectData
    }
  },
  mounted () {
    if (!(this.requestApi && !this.focusGet) && this.defaultActiveFirstOption && this.selectList?.length > 0) {
      if (this.isMultipleSelect) {
        this.$emit('update:value', [this.selectList[0][this.selectItem.value]])
        this.$emit('change', [this.selectList[0][this.selectItem.value]], this.selectList)
      } else {
        this.$emit('update:value', this.selectList[0][this.selectItem.value])
        this.$emit('change', this.selectList[0][this.selectItem.value], this.selectList)
      }
      this.$emit('init-success-call-back')
    }
  },
  methods: {
    // 数据请求
    getData (query) {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...query,
        ...this.setParams,
        ...omitBy(this.currentSearchParams, isEmpty)
      }
      request({ url: this.setUrlParams ? `${this.requestApi}/${this.setUrlParams}` : this.requestApi,
        method: 'get',
        params: params
      }).then(res => {
        // if (res.code === 200) {

          // 后台接口返回的字段不统一
          let arr = []
          if (this.sourseField) {
            arr = res || []
          } else {
            arr = res.rows || res.data || []
          }

          // 后台接口返回的数组单个元素
          if (this.sourceHandle) {
            arr = arr.map(element => {
              element = { realValue: element, label: element }
              return element
            });
          }
          this.selectList = this.selectList.concat(arr)
          // 当初始化时且传参默认选中第一条时自动填充
          if (this.isInit && this.defaultActiveFirstOption && this.selectList?.length > 0) {
            if (this.isMultipleSelect) {
              this.$emit('update:value', [this.selectList[0][this.selectItem.value]])
              this.$emit('change', [this.selectList[0][this.selectItem.value]], this.selectList)
            } else {
              this.$emit('update:value', this.selectList[0][this.selectItem.value])
              this.$emit('change', this.selectList[0][this.selectItem.value], this.selectList)
            }
            this.cancelFocus()
          }
          if (this.isInit) {
            this.$emit('init-success-call-back')
          }

          this.$emit('successCallBack', this.selectList)

          // 当数据只有一条时自动填充
          if (this.getOnlyDataSelect && this.selectList.length === 1) {
            this.$emit('update:value', this.selectList[0][this.selectItem.value])
            this.$emit('change', this.selectList[0][this.selectItem.value], this.selectList)
            this.cancelFocus()
          }

          // 当下拉框数据，某个字段为某个值时，自动默认该选项
          if (this.defaultSelect) {
            for (let i = 0; i < this.selectList.length; i++) {
              if (this.selectList[i][this.defaultSelect.defaultParam] === this.defaultSelect.defaultValue) {
                this.$emit('update:value', this.selectList[i][this.selectItem.value])
                this.$emit('change', this.selectList[i][this.selectItem.value], this.selectList)
                return
              }
            }
          }

          this.total = res.total || Number(this.totalNum)
          this.fetching = false
          this.isInit = false
        // }
      }, () => {
        this.isInit = false
        this.fetching = false
      })
    },
    // 选中
    selectChange (val) {
      this.$emit('update:value', val)
      this.$emit('input', val) // 更新v-model绑定的值
      this.$emit('change', val, this.selectList)
      // 搜索后选中，然后点击X清空，重新请求数据
      if ((!val || val?.length === 0) && this.searchTypeList.includes(this.selectType)) {
        this.handleSearch("")
      }
    },
    /** 滚动事件 */
    handlePopupScroll (e) {
        const { scrollHeight, scrollTop, clientHeight } = e.target
        if (this.pageNum * this.pageSize < this.total) {
          // if (scrollHeight - scrollTop === clientHeight) {
          if ((scrollHeight - clientHeight) / 2 <= scrollTop) {
              // 防抖节流
              if (this.timer) {
                return
              }
              this.timer = setTimeout(() => {
                this.timer = null
                this.pageNum = this.pageNum + 1
                this.getData()
              }, 500)
          }
        }
    },
    // 获取焦点
    focus () {
      if (this.focusGet) {
        this.fetching = true
        this.selectList = []
        this.pageNum = 1
        this.getData()
      }
    },
    // 搜索
    handleSearch (val) {
      const param = {}
      param[this.searchParam] = val
      this.currentSearchParams = param;
      // 防抖节流
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.timer = null
        this.selectList = []
        this.pageNum = 1
        this.fetching = true
        this.getData(param)
      }, 500)
    },
    // 匹配
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 选中后显示-非拼接
    labelHandleNoAssemble (item) {
      if (this.selectItem.thirdLabel) {
        return item[this.selectItem.thirdLabel]
      } else {
        return item[this.selectItem.label]
      }
    },
    // 选中后显示-拼接
    labelHandle (item) {
      if (this.assembleLabelThrid) {
        return item[this.selectItem.thirdLabel]
      } else if (this.assembleLabel) {
        return item[this.selectItem.label]
      } else {
        return item[this.selectItem.value]
      }
    },
    // 自由拼接label, 如工号-昵称-名字
    freeOptionAssemble(item) {
      let labelValue = '';
      const labelFieldList = Object.values(this.showLabel);
      if (labelFieldList?.length > 0) {
        labelFieldList.forEach((value, index) => {
          if (index === 0) {
            labelValue = item[value] || '空'
          } else {
            labelValue = labelValue + '-' + (item[value] || '空')
          }
        })
      }
      return labelValue;
    },
    // 下拉框显示
    optionAssemble (item) {
      if (this.selectItem.thirdLabelText) {
        return `${item[this.selectItem.label]}${this.thirdLabelHandle(item[this.selectItem.thirdLabel])}`
      } else if (this.selectItem.thirdLabel) {
        return `${item[this.selectItem.label]}-${item[this.selectItem.thirdLabel]}`
      } else {
        return `${item[this.selectItem.value]}-${item[this.selectItem.label]}`
      }
    },
    // 下拉框显示
    thirdLabelHandle (val) {
      if (val === "Y") {
        return `-${this.selectItem.thirdLabelText}`
      } else {
        return ""
      }
    },
    handleDropdownVisibleChange (isOpen) {
      if (isOpen) {
        this.timer = setTimeout(() => {
          this.selectList = []
          this.timer = null
          this.pageNum = 1
          this.fetching = true
          this.getData()
        }, 500)
      }
    },
    // 取消焦点
    cancelFocus () {
      this.$refs.mySelect.focus();
      this.$refs.mySelect.blur();
    }
  }
}
</script>
